module.exports = __webpack_public_path__ + "static/media/3e713838-824e-41c7-a110-e48ac1bd01e6.5ceadd24.png";